import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { CHROME_IMAGES } from "@/data/mockData";
import { authApi } from "@/lib/api";

export default function Login() {
  const [pw, setPw] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  async function submit(e) {
    e.preventDefault();
    if (!pw.trim()) { setErr("Password required."); return; }
    setLoading(true);
    try {
      await authApi.login(pw);
      nav("/admin/agents");
    } catch (ex) {
      setErr(ex.status === 401 ? "Wrong password." : "Login failed — try again.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="h-screen w-screen bg-[var(--ink)] text-white relative overflow-hidden">
      {/* Right side chrome hero */}
      <div className="absolute inset-y-0 right-0 w-1/2 hidden md:block">
        <img
          src={CHROME_IMAGES.loginHero}
          alt=""
          className="chrome-img w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[var(--ink)] via-transparent to-transparent" />
      </div>

      {/* Top brand */}
      <div className="absolute top-6 left-8 z-10 flex items-baseline gap-2">
        <span className="font-display italic text-[22px]">outreach</span>
        <span className="text-[10px] uppercase tracking-[0.32em] text-white/45">
          / admin
        </span>
      </div>

      {/* Centered form */}
      <div className="relative z-10 h-full flex items-center px-8 md:px-20">
        <div className="w-full max-w-[460px]">
          <div className="text-[11px] uppercase tracking-[0.28em] text-white/55 mb-5">
            Console — Restricted Access
          </div>

          <h1
            className="font-display font-black uppercase leading-[0.92] tracking-tight text-[60px] sm:text-[88px] text-white"
            data-testid="login-title"
          >
            <span className="tape dark">Admin</span>{" "}
            <span className="italic font-medium">console</span>
          </h1>

          <div className="mt-5 h-[3px] w-32 bg-[var(--blue)]" />

          <p className="mt-6 max-w-md text-white/65 text-[15px] leading-relaxed">
            UNIDEX LinkedIn outreach control. Sign in with the shared administrator password
            stored in server environment variables.
          </p>

          <form onSubmit={submit} className="mt-10 space-y-5">
            <label className="block">
              <span className="text-[10px] uppercase tracking-[0.24em] text-white/55">
                Password
              </span>
              <input
                type="password"
                autoFocus
                value={pw}
                onChange={(e) => setPw(e.target.value)}
                className="mt-2 w-full bg-transparent border-0 border-b border-white/30 focus:border-[var(--blue)] outline-none py-3 text-[18px] font-display"
                data-testid="login-password-input"
                placeholder="••••••••"
              />
            </label>

            {err && (
              <div
                className="text-rose-400 text-[12px] uppercase tracking-wide"
                data-testid="login-error"
              >
                {err}
              </div>
            )}

            <button
              type="submit"
              data-testid="login-submit-button"
              disabled={loading}
            className="w-full bg-[var(--blue)] hover:bg-[var(--blue-hover)] disabled:opacity-50 text-white px-6 py-4 text-[12px] uppercase tracking-[0.3em] transition-colors"
            >
              {loading ? "Signing in…" : "Sign in →"}
            </button>
          </form>

          <div className="mt-12 text-[11px] uppercase tracking-[0.22em] text-white/35">
            UNIDEX v2.0 · The Boston-style admin shell
          </div>
        </div>
      </div>
    </div>
  );
}
